/* eslint-disable no-unused-vars, react/sort-comp, no-shadow, react/jsx-no-bind */
import classnames from 'classnames';
import React, { Component, PropTypes } from 'react';
import { KeyHelpers } from 'es6/core/keys';
import ReactDmak from './dmak';

// Kanji that we have SWF files for.
const AVAILABLE_KANJI_SWF = 'あいうえおかがきぎくぐけげこごさざしじすずせぜそぞただちぢつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもやゆよらりるれろわをんアイウエオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモヤユヨラリルレロワヲン一丁七万三上下不世両並中丸主久乗九乱乳予争事二五亡交京人仁今仕他付代令以仮仲件休会伝似位低住体何余作使例供価便係保信修俳俵倉個倍候借停健側傷働億優元兄兆先光児入全八公六共兵具典内円冊再写冬冷処出刀分切刊列初判別利制刷券刻則前副割創劇力功加助努労効勇勉動務勝勢勤包化北区医十千午半卒協南単博印危卵厚原厳去参友反収取受口古句台史右号司各合同名后向君否告周味呼命和品員唱商問善喜器四回困囲図固国園土在地坂型城域堂報場塩境墓増士声売変夏夕外多夜夢大天太夫央失奏奮女好妹妻姉始委姿婦子字存孝季学孫宅宇守安完宗官宙定宝実客宣宮害家宿富寒察寺対専射将尊導小少尺局屋展属層山岩岸島川州巣工左差己巻市布希席帯帰帳干平年幸幹幼庁広底店府度座庫庭康延建弁式弓引弟弱張強当形役往径待後徒従得復心必志忘応忠念思急性息悪悲情想意愛感態慣憲成我戦戸所手才打批承技投折拝拡拾持指挙捨推提揮損操支改放政故救敗教散敬数整敵文料断新方旅族旗日旧早明易昔星映春昨昭昼時晩景晴暑暖暗暮暴曜曲書最月有服朗望朝期木未末本札机材村束条来東松板林果枝柱査栄校株根案桜梅械森植検業極楽様標模権横樹橋機欠次歌止正武歩歯歴死残段殺母毎毒比毛氏民気水氷永求池決汽河油治沿泉法波泣注泳洋洗活派流浅浴海消深混清済減温測港湖湯満源準漁漢潔潮激火灯災炭点無然焼照熟熱燃父片版牛牧物特犬犯状独率玉王班現球理生産用田由申男町画界畑留略番異疑病痛発登白百的皇皮皿益盛目直相省看県真眼着矢知短石砂研破確磁示礼社祝神票祭禁福私秋科秒秘税種穀積穴究空窓立章童競竹笑笛第筆等筋答策算管箱節築簡米粉精糖糸系紀約紅納純紙級素細終組経結給統絵絶絹続綿総緑線編練縦縮績織罪置署羊美群羽翌習老考者耕耳聖聞職肉肥育肺胃背胸能脈腸臓臣臨自至舌舎航船良色花芸芽若苦英茶草荷菜落葉蒸蔵薬虫蚕血衆行術街衛衣表裁装裏製複西要見規視覚覧親観角言計討訓記設許訳証評詞試詩話誌認誕語誠誤説読課調談論諸講謝識警議谷豆豊象貝負財貧貨責貯貴買貸費貿賃資賛賞質赤走起足路身車軍転軽輪輸辞農辺近返述追送通速造連週進遊運過道達遠適選遺郡部郵郷都配酒酸里重野量金針鉄銀銅銭鋼録鏡長門閉開間関閣防降限陛院除陸険陽隊階際障集雑難雨雪雲電青静非面革音頂順預領頭題顔願類風飛食飯飲飼養館首馬駅験骨高魚鳥鳴麦黄黒鼻';

// REGEXP for capturing japanese characters.
const KANJI_STROKE_REGEXP = /[\u3040-\u30FF\uFF61-\uFF9F\u4E00-\u9FFF\uF900-\uFAFF]/g;

/**
 * Checks if a SWF file is available.
 *
 * @param {String} char     the kanji character to check
 * @returns {Boolean}
 */
function isSWFAvailable(char) {
  return AVAILABLE_KANJI_SWF.match(char);
}

/**
 * Returns all kanji that have a SWF file available.
 *
 * @params {string} str    string containing kanji
 * @returns {String[]}
 */
function getAvailableKanji(str) {
  return getUniqueKanji(str).filter(isSWFAvailable);
}

/**
 * Retrieves all unique kanji characters from a string.
 *
 * @param {String} str
 * @returns {String[]}
 */
function getUniqueKanji(str) {
  const matched = str.match(KANJI_STROKE_REGEXP);
  return matched ? matched.filter((c, i) => str.indexOf(c) === i) : [];
}

/**
 *
 */
function handleKeydown(e) {
  const { keyCode } = e;
  const { characterIndex } = this.state;

  if (KeyHelpers.isLeft(keyCode)) {
    setCharacterIndex.call(this, characterIndex - 1);
  } else if (KeyHelpers.isRight(keyCode)) {
    setCharacterIndex.call(this, characterIndex + 1);
  }
}

/**
 * @this KanjiStrokes
 * @param {Number} characterIndex    sets the character index
 */
function setCharacterIndex(characterIndex) {
  const { characters } = this.props;
  const maxLength = getAvailableKanji(characters).length - 1;

  if (characterIndex >= 0 && characterIndex <= maxLength) {
    this.setState({ characterIndex });
  }
}

/**
 * Determines whether a string contains any characters that can be displayed.
 *
 * @param {String} str
 * @returns {Boolean}
 */
export function containsDisplayableCharacters(str) {
  return getAvailableKanji(str).length > 0;
}

const INITIAL_STATE = { characterIndex: 0 };

class KanjiStrokes extends Component {
  constructor(props) {
    super(props);
    this.handleKeydown = handleKeydown.bind(this);
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.characters !== this.props.characters) {
      this.setState(INITIAL_STATE);
    }
  }

  render() {
    const { characterIndex } = this.state;
    const { characters, onEscape } = this.props;

    const available = getAvailableKanji(characters);
    let availableIndex = 0;
    const uniqueCharacters = getUniqueKanji(characters);
    const focused = available[characterIndex];

    return (
      <div className="kanji-strokes">
        <div className="animation">
          {focused && <ReactDmak character={focused} />}
        </div>

        <div className="characters">
          {uniqueCharacters.map((char, i) => {
            const available = isSWFAvailable(char);
            const current = char === focused;
            const onClick = available && setCharacterIndex.bind(this, availableIndex);
            if (available) {
              availableIndex += 1;
            }
            return (<span key={i} onClick={onClick} className={classnames({ available, current })}>{char}</span>);
          })}
        </div>

        <div className="attribution">
          <a href="http://kanjivg.tagaini.net/">Kanji stroke data</a> by Ulrich Apel under <a href="http://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA 3.0</a>
        </div>

        <button className="btn btn-bar btn-default return-to-main" onClick={onEscape}>Esc</button>
      </div>
    );
  }
}

KanjiStrokes.propTypes = {
  characters: PropTypes.string.isRequired,
  onEscape: PropTypes.func.isRequired,
};

export default KanjiStrokes;
